import { MarkdownContent } from '@shared/components/markdown';

interface LayoutItemMarkdownProps {
  source: string;
  className?: string;
}

/**
 * The markdown of a text layout item, rendered.
 *
 * The same library that edits it renders it, and this one component is what both the builder and
 * the form go through, so what is typed and what is read cannot drift.
 *
 * `MarkdownContent` is the app's one markdown renderer, shared with chat. A form passes no
 * tokens — there are no mentions in an instruction — and asks for external links, because a
 * public form is served outside the app and has no router to hand an in-app path to.
 */
export function LayoutItemMarkdown({ source, className }: LayoutItemMarkdownProps) {
  return <MarkdownContent source={source} className={className} externalLinks />;
}
